import { getNumberOfFreePlugins, IConfirmationMsgVisibleResult } from '../../domain/free-plugin-provider';
import CircledCheckIcon from '../../../../../ui/svg/common/check-v-circled';
import FreePluginProgressBar from './free-plugin-progress-bar';
import React from 'react';
import TermsAndConditions from '../shared/terms-and-conditions';
import { ICartData } from '../../interfaces';

/**
 * if text should be in plural -> add s suffix
 */
export const plural = (text: string, count: number) => {
    return `${ text }${ count > 1 ? 's' : '' }`;
};

interface IFreePluginBoxProps {
    visibility: IConfirmationMsgVisibleResult;
    cartData: ICartData;
    classes?: string;
}

const FreePluginBox = ({ visibility, cartData, classes }: IFreePluginBoxProps) => {
    const numberOfFreePlugins = getNumberOfFreePlugins(cartData);

    return (
        <div className={ `text-gray-700 border border-green rounded bg-green-100 px-3 py-3 flex flex-col ${ classes ?? '' }` } role="alert">
            <>
                {
                    visibility.addMoreEnabled &&
                    <div className="flex items-center gap-2">
                        <CircledCheckIcon
                            width="24"
                            height="24"
                            bgColor="#00BA90"
                        />

                        <div>
                            <p
                                style={{
                                    letterSpacing: '-0.2px',
                                }}
                                className="font-bold md:whitespace-nowrap">
                                Your cart is eligible for { numberOfFreePlugins } free { plural('plugin', numberOfFreePlugins) }.
                            </p>

                            <p
                                style={{
                                    letterSpacing: '-0.1px',
                                }}
                                className="text-xs">
                                An email to select { numberOfFreePlugins === 1 ? 'it' : 'them' } will be sent after checkout.
                            </p>
                        </div>
                    </div>
                }
            </>

            {
                visibility.progressBarEnabled &&
                <FreePluginProgressBar
                    cartData={ cartData }
                    classes={ visibility.addMoreEnabled ? 'mt-4' : '' }
                />
            }

            {
                !visibility.progressBarEnabled &&
                <div className="flex items-center gap-4">
                    <div className="flex-1">&nbsp;</div>
                    <p>
                        <TermsAndConditions url={ cartData.efstcurl } />
                    </p>
                </div>
            }
        </div>
    )
};

export  default FreePluginBox;